import styled, {css} from 'styled-components';

import {
  ActionButtonDropdown as BaseActionButtonDropdown,
  ActionButtonOption as BaseActionButtonOption,
  TActionButtonOptionProps,
} from '@edna/components';
import {mixins} from '@edna/components/styles';

export const BUTTON_SIZE = 48;
export const BUTTON_RIGHT_OFFSET = 40;
export const BUTTON_BOTTOM_OFFSET = 40;

export const WidgetButton = styled.div<{isFixed?: boolean; isOpen?: boolean}>`
  ${mixins.wh(`${BUTTON_SIZE}px`)}
  ${mixins.stack({align: 'center', justify: 'center'})}

  position: relative;
  cursor: pointer;

  ${({isFixed, theme}) =>
    isFixed &&
    css`
      position: fixed;
      right: ${BUTTON_RIGHT_OFFSET}px;
      bottom: ${BUTTON_BOTTOM_OFFSET}px;
      z-index: ${theme.zIndex.notifications};
    `}

  border-radius: 50%;

  ${({theme}) => css`
    background-color: ${theme.palette.brandAccent400};
    color: ${theme.palette.grey900};
  `}

  ${({isOpen, theme}) =>
    isOpen &&
    css`
      background-color: ${theme.palette.brandAccent500};
      cursor: not-allowed;
    `}
`;

export const ActionButtonDropdown = styled(BaseActionButtonDropdown)`
  position: fixed;
  right: ${BUTTON_RIGHT_OFFSET}px;
  bottom: ${BUTTON_BOTTOM_OFFSET}px;
  ${({theme}) => css`
    z-index: ${theme.zIndex.notifications};
  `}
`;

export const ActionButtonOption = styled(BaseActionButtonOption)<TActionButtonOptionProps>`
  ${({isHovered, theme}) =>
    isHovered
      ? css`
          background-color: ${theme.palette.brandAccent400};
          color: ${theme.color.primary};
        `
      : css`
          background-color: ${theme.color.primary};
          color: ${theme.color.white};
        `}
`;

export const Counter = styled.div`
  position: absolute;

  top: -1px;
  right: -1px;
  min-width: 16px;
  min-height: 16px;
  border-radius: 50%;
  ${mixins.stack({justify: 'center', align: 'center'})}
  ${mixins.f1}
  font-weight: 600;

  ${({theme}) => css`
    background-color: ${theme.palette.pink400};
    border: 1px solid ${theme.color.white};
    color: ${theme.color.white};
  `};
`;
